import { useEffect, useState } from 'react';
import { lireBuildInfo, type GsDeploymentSlotState } from './useBuildInfo';

// Le type vit avec la lecture partagee de `/api/version` (useBuildInfo) ; re-exporte ici : c est
// son chemin historique.
export type { GsDeploymentSlotState } from './useBuildInfo';

/**
 * Second temoin, independant du serveur : l adresse de l emplacement (`<site>-preprod.
 * azurewebsites.net`) et son domaine (`<app>-preprod.groupesignalisation.ca`).
 */
export function isPreprodHostname(hostname: string): boolean {
  return /-preprod\./i.test(hostname);
}

/**
 * `preprod` des qu UN des deux temoins le dit (l adresse de la page, ou le champ
 * `emplacement` de `/api/version`, que le serveur tire du reglage collant `GS_EMPLACEMENT`).
 * Une erreur reseau ou une reponse illisible rend `unknown`, jamais `preprod` : la
 * production n affiche pas le bandeau sur une panne.
 *
 * La lecture de `/api/version` (a l origine de la page, jamais `VITE_API_URL` : cette adresse
 * est figee a la construction sur la PRODUCTION) est celle de `useBuildInfo` : une seule par
 * page, partagee avec l affichage de la version.
 */
export function useDeploymentSlot(): GsDeploymentSlotState {
  const [slot, setSlot] = useState<GsDeploymentSlotState>(() =>
    typeof window !== 'undefined' && isPreprodHostname(window.location.hostname) ? 'preprod' : 'unknown',
  );

  useEffect(() => {
    if (slot === 'preprod') return;
    let cancelled = false;
    void lireBuildInfo().then((info) => {
      if (!cancelled) setSlot(info.slot);
    });
    return () => {
      cancelled = true;
    };
    // Une lecture par page : l instance qui a servi la page ne change pas sous elle.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return slot;
}
